import { useAppSelector } from "@hooks/store"
import { useReceivedPaymentDetailContext } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/context/ReceivedPaymentDetailContext"
import { useReceivedPaymentDetailServices } from "@pages/collectionAdministration/pages/ReceivedPaymentDetail/hooks/useReceivedPaymentDetailServices"
import useCurrentLocation from "@thooks/useCurrentLocation"
import { useCallback, useEffect, useState } from "react"

export const useUpdateAmountModal = ({ handleOpenCloseModal, record, isOpen }) => {
    const { param } = useCurrentLocation()
    const { currencySymbol } = useAppSelector(state => state.auth)
    const { getInitialData } = useReceivedPaymentDetailContext()
    const { getChargeInstanceDebtorDetailService, updateChargeInstanceDebtorService } = useReceivedPaymentDetailServices()
    const [debtorPaymentDetailData, setDebtorPaymentDetailData] = useState(null)
    const [newDebtorPaymentDetailData, setNewDebtorPaymentDetailData] = useState(null)
    const [loadingReceivedPaymentDetail, setLoadingReceivedPaymentDetail] = useState(false)

    const getInitialDataModal = useCallback(async () => {
        const res = await getChargeInstanceDebtorDetailService({
            charge_instance_id: param.chargeInstanceId,
            place_id: record.place_id,
            setLoading: setLoadingReceivedPaymentDetail
        })
        setDebtorPaymentDetailData(res.data)
        setNewDebtorPaymentDetailData(res.data)
        setLoadingReceivedPaymentDetail(false)
    }, [getChargeInstanceDebtorDetailService, param.chargeInstanceId, record?.place_id])

    const handleSaveUpdateAmount = async () => {
        const newJsonData = {
            charge_instance_id: parseInt(param.chargeInstanceId),
            place_id: record.place_id,
            debtor_detail: newDebtorPaymentDetailData?.details?.map((item) => ({ ...item, total: item.total ?? 0 })),
            taxes: newDebtorPaymentDetailData?.taxes?.map((item) => ({ ...item, total: item.total ?? 0 })),
            totals: newDebtorPaymentDetailData?.totals
        }
        await updateChargeInstanceDebtorService({ jsonData: newJsonData, setLoading: setLoadingReceivedPaymentDetail })
        await getInitialData({ charge_instance_id: param.chargeInstanceId })
        setLoadingReceivedPaymentDetail(false)
        setDebtorPaymentDetailData(null)
        setNewDebtorPaymentDetailData(null)
        handleOpenCloseModal({ isOpenModal: false, name: 'update_amount' })
    }

    const handleDetailChange = (index, value) => {
        setNewDebtorPaymentDetailData((prevState) => {
            const updatedDetails = [...prevState.details];
            updatedDetails[index] = {
                ...updatedDetails[index],
                total: value
            };
            return {
                ...prevState,
                details: updatedDetails
            };
        });
    };

    const handleTaxChange = (index, value) => {
        setNewDebtorPaymentDetailData((prevState) => {
            const updatedTaxes = [...prevState.taxes];
            updatedTaxes[index] = {
                ...updatedTaxes[index],
                total: value
            };
            return {
                ...prevState,
                taxes: updatedTaxes
            };
        });
    };

    const handleTotalsChange = (field, value) => {
        setNewDebtorPaymentDetailData((prevState) => ({
            ...prevState,
            totals: {
                ...prevState.totals,
                [field]: value ?? 0
            }
        }));
    };

    const handleCloseModal = () => {
        setLoadingReceivedPaymentDetail(false)
        setDebtorPaymentDetailData(null)
        setNewDebtorPaymentDetailData(null)
        handleOpenCloseModal({ isOpenModal: false, name: 'update_amount' })
    }

    useEffect(() => {
        if (!isOpen) return
        getInitialDataModal()
    }, [getInitialDataModal, isOpen])


    return {
        currencySymbol,
        debtorPaymentDetailData,
        newDebtorPaymentDetailData,
        loadingReceivedPaymentDetail,
        handleCloseModal,
        handleSaveUpdateAmount,
        handleDetailChange,
        handleTaxChange,
        handleTotalsChange
    }
}